<div class="text-center">
  <i class="fa fa-spinner fa-pulse fa-4x"></i>
</div>


// WEBPACK FOOTER //
// ./src/app/spinner/spinner.component.html